import { Link } from "react-router-dom";
import { useBusiness } from "../context/BusinessContext";

export default function Footer() {
  const { business } = useBusiness();
  return (
    <footer className="mt-32 border-t border-neutral-900/10 bg-[#0a0a0a] text-neutral-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="font-black text-xl tracking-tighter text-white">
            {business.name || "SHOP"}
          </div>
          <p className="text-sm text-neutral-400 mt-4 leading-relaxed">
            {business.about || business.tagline || "Modern essentials, thoughtfully made."}
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-ultra text-neutral-500 mb-4">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-accent" to="/shop">All products</Link></li>
            <li><Link className="hover:text-accent" to="/shop?featured=true">Featured</Link></li>
            <li><Link className="hover:text-accent" to="/cart">Cart</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-ultra text-neutral-500 mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-neutral-300">
            <li>{business.email || "—"}</li>
            <li>{business.phone || "—"}</li>
            <li className="text-neutral-400">{business.address || ""}</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-ultra text-neutral-500 mb-4">Admin</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-accent" to="/admin">Dashboard</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-xs text-neutral-500 text-center">
        © {new Date().getFullYear()} {business.name}. All rights reserved.
      </div>
    </footer>
  );
}
